// extracted by mini-css-extract-plugin
export default {"container":"CipDJ","logo":"Ba4x6","logoImage":"Ag8Su","logoBackground":"v4C2G","title":"f6Mxw","subtitle":"LgsjA","list":"FCkco"};